// @ts-nocheck

import { useEffect, useState } from "react";
import ReactECharts from "echarts-for-react";
import useStoreTimToa from "../../../store/useStoreTimToa";
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";
import { Icons } from "../../spinner";

export function ChartFleetTrackBars() {
  const [options, setOptions] = useState({});
  const { fleetData, loadingChartFleet } = useStoreTimToa((state) => state);

  const formatCurrency = (value: string) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(parseFloat(value.replace(".", "").replace(",", ".")));
  };

  const formatNumber = (value: number) => {
    return new Intl.NumberFormat("pt-BR").format(value);
  };

  const updateOptions = () => {
    if (!fleetData) return;

    const supervisors = fleetData.abastecimentos_por_supervisor;

    const option = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        formatter: function (params: any) {
          const dataIndex = params[0].dataIndex;
          const supervisor = supervisors[dataIndex];
          return `
            <strong>${supervisor.nome_supervisor}</strong><br/>
            Filial: ${supervisor.filial}<br/>
            ${params[0].seriesName}: ${params[0].value.toFixed(2)}
          `;
        },
      },
      grid: [
        {
          top: 50,
          right: 50,
          bottom: "55%",
          left: 200,
          containLabel: true,
        },
        {
          top: "55%",
          right: 50,
          bottom: 50,
          left: 200,
          containLabel: true,
        },
      ],
      xAxis: [
        {
          type: "value",
          name: "Litros",
          position: "top",
          splitLine: {
            lineStyle: {
              type: "dashed",
            },
          },
        },
        {
          type: "value",
          name: "KM/L",
          gridIndex: 1,
          position: "top",
          splitLine: {
            lineStyle: {
              type: "dashed",
            },
          },
        },
      ],
      yAxis: [
        {
          type: "category",
          data: supervisors.map((s) => s.nome_supervisor),
          axisLabel: {
            fontSize: 12,
            width: 150,
            overflow: "break",
            interval: 0,
          },
        },
        {
          gridIndex: 1,
          type: "category",
          data: supervisors.map((s) => s.nome_supervisor),
          axisLabel: {
            fontSize: 12,
            width: 150,
            overflow: "break",
            interval: 0,
          },
        },
      ],
      series: [
        {
          name: "Consumo em Litros",
          type: "bar",
          data: supervisors.map((s) => s.litros),
          itemStyle: {
            color: "#3b82f6",
          },
          label: {
            show: true,
            position: "right",
            formatter: "{c} L",
            color: "#ffffff",
          },
        },
        {
          name: "Média KM/L",
          type: "bar",
          xAxisIndex: 1,
          yAxisIndex: 1,
          data: supervisors.map((s) => s.media_km_por_litro),
          itemStyle: {
            color: "#10b981",
          },
          label: {
            show: true,
            position: "right",
            formatter: "{c} km/L",
            color: "#ffffff",
          },
        },
      ],
    };

    setOptions(option);
  };

  useEffect(() => {
    if (fleetData) {
      updateOptions();
    }
  }, [fleetData]);

  return (
    <>
      {fleetData && fleetData.abastecimentos_por_supervisor?.length > 0 ? (
        <div className="bg-gray-500 shadow-md rounded-sm col-span-2 flex flex-row">
          <ReactECharts option={options} style={{ height: "600px", width: "80%" }} />
          <div className="flex flex-col gap-4 justify-center items-center">
            <Card className="w-[200px]">
              <CardHeader className="pb-2">
                <CardTitle className="text-sm font-medium">Total Abastecido</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold">
                  {formatCurrency(fleetData.total_abastecido_valor)}
                </div>
                <p className="text-xs text-muted-foreground">
                  {formatNumber(fleetData.total_de_abastecimentos)} abastecimentos
                </p>
              </CardContent>
            </Card>
            <Card className="w-[200px]">
              <CardHeader className="pb-2">
                <CardTitle className="text-sm font-medium">Total Litros</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold">
                  {formatNumber(fleetData.total_litros)}
                </div>
                <p className="text-xs text-muted-foreground">Litros consumidos</p>
              </CardContent>
            </Card>
            <Card className="w-[200px]">
              <CardHeader className="pb-2">
                <CardTitle className="text-sm font-medium">
                  Quilômetros Rodados
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold">
                  {formatNumber(fleetData.total_km_rodados)}
                </div>
                <p className="text-xs text-muted-foreground">Total KM</p>
              </CardContent>
            </Card>
          </div>
        </div>
      ) : loadingChartFleet ? (
        <div className="h-[450px] bg-gray-500 flex justify-center items-center rounded-sm col-span-2">
          <Icons.spinner className="h-12 w-12 animate-spin text-orange-300" />
        </div>
      ) : (
        <div className="h-[450px] bg-gray-500 flex justify-center items-center rounded-sm col-span-2">
          <p className="bg-slate-100 p-2 text-gray-500 rounded-md font-extrabold">
            SEM DADOS
          </p>
        </div>
      )}
    </>
  );
}
